import { React, useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import SchoolRegister from './pages/School/SchoolRegister';
import ForgetPassword from './pages/School/ForgetPassword.js';
import LoginForm from './pages/LoginForm';
import StudentRegister from './pages/Student/StudentRegister';
import StudentAllData from './pages/Student/StudentAllData';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CastewiseReport from './pages/Student/CastewiseReport';
import Minority from './pages/Student/Minority';
import AgewiseReport from './pages/Student/AgewiseReport';
import SchoolData from './pages/SchoolData';
// import CharacterCert from './pages/Student/CharacterCert.js';
import Sidebar from './components/Sidebar';
import Leaving from './pages/Student/Leaving';
import OutwardRegister from './pages/Student/OutwardRegister.js';
import Importexport from './pages/Student/Importexport';
import Bonafide from './pages/Student/Bonafide';
import IdCard from './pages/Student/IdCard';
import Sadhyachasatha from './pages/Poshanaahar/Sadhyachasatha';
import Kird from './pages/Kird/Kird';
import GunaNeendani from './pages/result/GunaNeendani';
import ProgressSheet from './pages/result/ProgressSheet';
import SubjectwiseReport from './pages/result/SubjectWiseResult';
import Avaksatha from './pages/Poshanaahar/Avaksatha';
import Magani from './pages/Poshanaahar/Magani';
import Praman from './pages/Poshanaahar/Praman';
import Menu from './pages/Poshanaahar/Menu';
import DainandiNondvahi from './pages/Poshanaahar/DainandinNondvahi';
import GeneralRegister from './pages/Student/GeneralRegister';
import WithAuth from '../src/WithAuth';
import PaymentPage from './pages/PaymentIntegration/PaymentPage';
import Collectout from './pages/result/Collectout';
import GradeWise from './pages/result/GradeWise';
import DailyRegister from './pages/result/DailyRegister';
import Failed from './pages/result/Failed';
import LandingPage from './pages/PaymentIntegration/LandingPage';
import Downloadexe from './pages/PaymentIntegration/Downloadexe';
import RollNo from './pages/Student/RollNo';
import BoardResult from './pages/result/BoardResult';
import CombinedResult9th10th from './pages/result/CombinedResult9th10th';
import ShifarasForm from './pages/Student/ShifarasForm';
import Form15A from './pages/Student/Form15A';

import PresentySheet from './pages/Attendance/PresentySheet';
import PresentyReport from './pages/Attendance/PresentyReport';
import Icse from './pages/IcseResult/Icse';
import IcseMarkRegisteration from './pages/IcseResult/IcseMarkRegisteration';
import IcseResult from './pages/IcseResult/IcseResult';
import IcseGradeWise from './pages/IcseResult/IcseGradeWise.js';
import IcseSubjectWise from './pages/IcseResult/IcseSubjectWise.js';
import PrelimsResult from './pages/IcseResult/PrelimsResult.js'
import PrelimsMarkEntry from './pages/IcseResult/PrelimsMarkEntry.js'

import DainandinReport from './pages/Poshanaahar/DainandinReport';
import Defaultsettings from './pages/School/Defaultsettings';
import PermissionAccess from './pages/School/PermissionAccess';

import ChavReport from './pages/Poshanaahar/ChavReport';
import PersonalData from './pages/Student/PersonalData';
import BMICalculation from './pages/Poshanaahar/BMICalculation';
import DainandinNondvahiTandulkReport from './pages/Poshanaahar/DainandinNondvahiTandulkReport';
import Certificate from './pages/Poshanaahar/Certificate';
import EggandBananaRegisterBook from './pages/Poshanaahar/EggandBananaRegisterBook';
import Receipt from './pages/Fee/Receipt.js';
import Stdfee from './pages/Fee/Stdfee.js';
import Pavati from './pages/Fee/Pavati.js';
import Pavatino from './pages/Fee/Pavatino.js';
import Pavatino1 from './pages/Fee/Pavatino1.js';
import Driver from './pages/Fee/Driver.js';
import Yearpavati from './pages/Fee/Yearpavati.js';
import UpadatedReport from './pages/Fee/UpadatedReport.js';
import Feepavati from './pages/Fee/Feepavati.js';
import Feepavati2 from './pages/Fee/Feepavati2.js';
import Rootpavati from './pages/Fee/Rootpavati.js';
import Driverpavati from './pages/Fee/Driverpavati.js';
import Distribution from './pages/Student/Distribution.js';
import StudentTestPage from './pages/Exam/Test.js';
import TakeTest from './pages/Exam/TakeTest.js';
import TeacherAndQuestionForm from './pages/Exam/TeacherAndQuestionForm.js';
import StudentResult from './pages/Exam/StudentResult.js';
import AddPendingfee from './pages/Fee/AddPendingfee.js';

import MarkEnteryHSC from './pages/result/MarkEntryHSC.js';
import MarkEnterySSC from './pages/result/MarkEnterySSC.js';
import ResultHSC from './pages/result/ResultHSC.js';
import ResultSSC from './pages/result/ResultSSC.js';
import AllMarksPath from './pages/result/AllMarksPath.js';
import StudentProgresswithout from './pages/result/StudentProgresswithout.js';
import StudentProgress from './pages/IcseResult/StudentProgresswith.js';
import NirgamReport from './pages/Student/NirgamReport.js';
import UpdateStudentPhotos from './pages/UpdateStudentPhoto.js';


import Instock from './pages/Inventory/Instock.js';
import Outstock from './pages/Inventory/Outstock.js';
import BalanceStock from './pages/Inventory/BalanceStock.js';
import Award_Certificate from './pages/Ceritificates/Award_Certificate.js';


import AddTeacher from './pages/Teacher/AddTeacher.js'
import AttendanceStaffReport from './pages/Teacher/AttendanceStaffReport.js';
import BankDetails from './pages/Teacher/BankDetails.js';
import DailyReport from './pages/Teacher/DailyReport.js';
import DateOfJoinReport from './pages/Teacher/DateOfJoinReport.js';
import EditAtendance from './pages/Teacher/EditAtendance.js';
import FemaleStaffReport from './pages/Teacher/FemaleStaffReport.js';
import MaleStaffReport from './pages/Teacher/MaleStaffReport.js';
import Profile from './pages/Teacher/Profile.js';
import SalaryDetails from './pages/Teacher/SalaryDetails.js';
import ShiftTime from './pages/Teacher/ShiftTime.js';
import TeacherInfo from './pages/Teacher/TeacherInfo.js';
import TeacherInfoReport from './pages/Teacher/TeacherInfoReport.js';
import TotalStaffReport from './pages/Teacher/TotalStaffReport.js';
import ViewAttendance from './pages/Teacher/ViewAttendance.js';
import UserPermission from './pages/Teacher/UserPermission.js';
import TIdCard from './pages/Teacher/TIdCard.js';

import WebResult from './pages/WebResults/WebResult.js';
import WebHSC from './pages/WebResults/WebHSC.js'
import WebSSC from './pages/WebResults/WebSSC.js';
import WebBoardResult from './pages/WebResults/WebBoardResult.js';
import WebIcseResult from './pages/WebResults/WebIcseResult.js';
import WebPrelimsResult from './pages/WebResults/WebPrelimResult.js';

import AddSubject from './pages/Timetable/AddSubject.js'
import PrincipleForm from './pages/Timetable/PrincipleForm.js';
import TeacherTimetable from './pages/Timetable/TeacherTimetable.js';
import TimetableForm from './pages/Timetable/TimetableForm.js';
import Timetableform1 from './pages/Timetable/Timetableform1.js';
import WeekdayForm from './pages/Timetable/WeekdayForm.js';
import PromoteStd from './pages/PromoteStd.js';
import StudentDashboard from './pages/Student/StudentDashboard.js';
import SchoolAdmissionForm from './pages/Student/SchoolAdmissionForm.js';
import AdmissionData from './pages/School/AdmissionData.js';

import PreparimaryResult from './pages/CBSE/PreparimaryResult.js';
import CbseSubjectWise from './pages/CBSE/CbseSubjectWise.js';
import CbseMarkEntery from './pages/CBSE/CbseMarkEntery.js';
import CbseResult from './pages/CBSE/CbseResult.js';
import WhatsAppSender from './pages/Fee/WhatsAppSender.js';
import CbseHighSchoolResult from './pages/CBSE/CbseHighSchoolResult.js';
import Plans from './components/Plans.js';
import SchoolregNoOTP from './pages/School/SchoolregNoOTP.js';
import WhatsAppManagement from './pages/School/WhatsAppManagement.js';



import ActiveModuleTracker from './ActiveModuleTracker';
import Department from './pages/Department.js';
import FeeDashboard from './pages/Fee/FeeDashboard.js';
import Divisionwisefee from './pages/Fee/Divisionwisefee.js';
import Stdfeenamelist from './pages/Fee/Stdfeenamelist.js';
import Plansforuser from './pages/Plansforuser.js';
import CustomerFeedback from './pages/Crm/CustomerFedback.js';
// import CustomerSupportSystem from './pages/Crm/CustomerSupport.js';



const AuthenticatedApp = () => {
  // Retrieve user data from localStorage
  const user = {
    status: localStorage.getItem('userStatus') || 'FFJGHKUMGFFJGHUG5376845344DD5435454FF54sdgfasfgasgfssdfbisygfsbsgbkhldfg54574654fgdfsgAFYFGYGHBVFHH54654', // Default to 'admin' if not found
    selectedPages: JSON.parse(localStorage.getItem('selectedPages')) || [],
  };




  // ProtectedRoute component to check if a module is locked
  const ProtectedRoute = ({ children, requiredModule }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isLocked, setIsLocked] = useState(false);
    const location = useLocation();

    useEffect(() => {
      const checkModuleAccess = async () => {
        try {
          const udiseNumber = localStorage.getItem("udiseNumber");
          if (!udiseNumber) {
            console.log("No udiseNumber found in localStorage - assuming unlocked");
            setIsLocked(false);
            setIsLoading(false);
            return;
          }

          const response = await fetch(`https://digischoolweb-default-rtdb.firebaseio.com/Admin/${udiseNumber}.json`);
          if (!response.ok) {
            setIsLocked(false);
            setIsLoading(false);
            return;
          }

          const data = await response.json();
          const moduleLockData = data?.lockedModule || data?.lockedModules;

          console.log(`Module check for ${requiredModule}:`, moduleLockData?.[requiredModule]);

          // Only lock if the module specifically has "locked" value or boolean true
          if (moduleLockData && (moduleLockData[requiredModule] === 'locked' || moduleLockData[requiredModule] === true)) {
            console.log(`${requiredModule} is locked`);
            setIsLocked(true);
          } else {
            console.log(`${requiredModule} is unlocked or not specified`);
            setIsLocked(false);
          }
        } catch (error) {
          console.error("Error checking module access:", error);
          setIsLocked(false); // Default to UNLOCKED on error so accessible modules are not blocked
        } finally {
          setIsLoading(false);
        }
      };

      checkModuleAccess();
    }, [requiredModule]);

    if (isLoading) {
      return <div>Loading...</div>;
    }

    if (isLocked) {
      return <Navigate to="/module-locked" state={{ from: location, moduleName: requiredModule }} replace />;
    }

    // If we get here, the module is not locked
    return children;
  };



  // Module Locked Page component
  const ModuleLockedPage = () => {
    const location = useLocation();
    const moduleName = location.state?.moduleName || "This module";
    const language = localStorage.getItem('language') || 'English';
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      const fetchPrice = async () => {
        try {
          const udiseNumber = localStorage.getItem("udiseNumber");
          if (udiseNumber) {
            const response = await fetch(`https://digischoolweb-default-rtdb.firebaseio.com/Admin/${udiseNumber}/purchesPlan/${moduleName}.json`);
            if (response.ok) {
              await response.json();
            }
          }
        } catch (err) {
          console.error("Error in fetchPrice:", err);
        } finally {
          setLoading(false);
        }
      };
      fetchPrice();
    }, [moduleName]);




    return (
      <div className="module-locked-container main-content-of-page" style={{ padding: '50px', textAlign: 'center' }}>
        <h2>{language === 'English' ? 'Module Locked' : 'मॉड्यूल लॉक आहे'}</h2>
        <p>
          {language === 'English'
            ? `${moduleName} is currently locked. Please contact your administrator to unlock this feature.`
            : `${moduleName} सध्या लॉक आहे. कृपया हे वैशिष्ट्य अनलॉक करण्यासाठी आपल्या प्रशासकाशी संपर्क साधा.`}
        </p>
        <button
          onClick={() => window.history.back()}
          style={{ padding: '10px 20px', cursor: 'pointer' }}
          className="me-3">
          {language === 'English' ? 'Go Back' : 'मागे जा'}
        </button>

      </div>
    );
  };




  return (
    <>
      <ActiveModuleTracker />
      <Sidebar user={user} />
      <Routes>

        <Route path="/module-locked" element={<ModuleLockedPage />} />
        <Route path="/school-data" element={<SchoolData />} />
        <Route path="/home" element={<Home />} />
        <Route path="/stddashboard" element={<StudentDashboard />} />
        <Route path="/student-register" element={<StudentRegister />} />
        <Route path="/all-student-report" element={<StudentAllData />} />
        <Route path="/caste-report" element={<CastewiseReport />} />
        <Route path="/minority-report" element={<Minority />} />
        <Route path="/agewisereport" element={<AgewiseReport />} />
        <Route path="/leaving-certificate" element={<Leaving />} />
        <Route path='/outwordReg' element={<OutwardRegister />} />
        <Route path="/importexport" element={<Importexport />} />
        <Route path="/bonafide" element={<Bonafide />} />
        {/* <Route path="/charactercertificate" element={<CharacterCert />} /> */}
        <Route path="/IdCard" element={<IdCard />} />
        <Route path="/generalregister" element={<GeneralRegister />} />
        <Route path="/stdpersonaldata" element={<PersonalData />} />
        <Route path="/certificates" element={<Award_Certificate />} />
        <Route path="/shifaras-form" element={<ShifarasForm />} />
        <Route path="/form-15a" element={<Form15A />} />
        {/* <Route path="/cus" element={<CustomerSupportSystem />} /> */}




        <Route
          path="/kird"
          element={
            <ProtectedRoute requiredModule="Account">
              <Kird />
            </ProtectedRoute>
          }
        />           <Route path="/GunaNeendani" element={
          <ProtectedRoute requiredModule="Result">
            <GunaNeendani />
          </ProtectedRoute>
        } />
        <Route path="/progresssheet" element={
          <ProtectedRoute requiredModule="Result">
            <ProgressSheet />
          </ProtectedRoute>
        } />
        <Route path="/subjectwise" element={
          <ProtectedRoute requiredModule="Result">
            <SubjectwiseReport />
          </ProtectedRoute>
        } />
        <Route path="/collectout" element={
          <ProtectedRoute requiredModule="Result">
            <Collectout />
          </ProtectedRoute>
        } />
        <Route path="/gradewise" element={
          <ProtectedRoute requiredModule="Result">
            <GradeWise />
          </ProtectedRoute>
        } />
        <Route path="/dailyregister" element={
          <ProtectedRoute requiredModule="Result">
            <DailyRegister />
          </ProtectedRoute>
        } />
        <Route path="/failed" element={
          <ProtectedRoute requiredModule="Result">
            <Failed />
          </ProtectedRoute>
        } />
        <Route path="/boardresult" element={
          <ProtectedRoute requiredModule="Result">
            <BoardResult />
          </ProtectedRoute>
        } />
        <Route path="/combinedresult9th10th" element={
          <ProtectedRoute requiredModule="Result">
            <CombinedResult9th10th />
          </ProtectedRoute>
        } />
        <Route path="/rollNo" element={<RollNo />} />
        <Route path="/Icse" element={
          <ProtectedRoute requiredModule="Result">
            <Icse />
          </ProtectedRoute>
        } />
        <Route path="/IcseMarkRegisteration" element={
          <ProtectedRoute requiredModule="Result">
            <IcseMarkRegisteration />
          </ProtectedRoute>
        } />
        <Route path="/IcseResult" element={
          <ProtectedRoute requiredModule="Result">
            <IcseResult />
          </ProtectedRoute>
        } />
        <Route path="/IcseGradeWise" element={
          <ProtectedRoute requiredModule="Result">
            <IcseGradeWise />
          </ProtectedRoute>
        } />
        <Route path="/IcseSubjectWise" element={
          <ProtectedRoute requiredModule="Result">
            <IcseSubjectWise />
          </ProtectedRoute>
        } />
        <Route path="/PrelimsResult" element={
          <ProtectedRoute requiredModule="Result">
            <PrelimsResult />
          </ProtectedRoute>
        } />
        <Route path="/PrelimsMarkEntry" element={
          <ProtectedRoute requiredModule="Result">
            <PrelimsMarkEntry />
          </ProtectedRoute>
        } />
        <Route path="/markenterhsc" element={
          <ProtectedRoute requiredModule="Result">
            <MarkEnteryHSC /> </ProtectedRoute>
        } />
        <Route path="/markenterssc" element={
          <ProtectedRoute requiredModule="Result">
            <MarkEnterySSC /> </ProtectedRoute>
        } />
        <Route path="/resulthsc" element={
          <ProtectedRoute requiredModule="Result">
            <ResultHSC />
          </ProtectedRoute>
        } />
        <Route path="/resultssc" element={
          <ProtectedRoute requiredModule="Result">
            <ResultSSC />
          </ProtectedRoute>
        } />
        <Route path="/allmarkspath" element={
          <ProtectedRoute requiredModule="Result">
            <AllMarksPath />  </ProtectedRoute>
        } />
        <Route path="/prgReportwtd" element={
          <ProtectedRoute requiredModule="Result">
            <StudentProgress />  </ProtectedRoute>
        } />
        <Route path="/prgReportwd" element={<ProtectedRoute requiredModule="Result">
          <StudentProgresswithout />  </ProtectedRoute>} />


        <Route path="/presentysheet" element={<PresentySheet />} />
        <Route path="/presentyreport" element={<PresentyReport />} />


        <Route path="/sadhyachasatha" element={
          <ProtectedRoute requiredModule="MDM">
            <Sadhyachasatha />
          </ProtectedRoute>
        } />
        <Route path="/aavaksatha" element={
          <ProtectedRoute requiredModule="MDM">
            <Avaksatha />
          </ProtectedRoute>
        } />
        <Route path="/magani" element={
          <ProtectedRoute requiredModule="MDM">
            <Magani />
          </ProtectedRoute>
        } />
        <Route path="/praman" element={
          <ProtectedRoute requiredModule="MDM">
            <Praman />
          </ProtectedRoute>
        } />
        <Route path="/menu" element={
          <ProtectedRoute requiredModule="MDM">
            <Menu />
          </ProtectedRoute>
        } />
        <Route path="/dainandin" element={
          <ProtectedRoute requiredModule="MDM">
            <DainandiNondvahi />
          </ProtectedRoute>
        } />
        <Route path="/dainandinNondreport" element={
          <ProtectedRoute requiredModule="MDM">
            <DainandinReport />
          </ProtectedRoute>
        } />
        <Route path="/tandalachinondavahi" element={
          <ProtectedRoute requiredModule="MDM">
            <DainandinNondvahiTandulkReport />
          </ProtectedRoute>
        } />
        <Route path="/chavreport" element={
          <ProtectedRoute requiredModule="MDM">
            <ChavReport />
          </ProtectedRoute>
        } />
        <Route path="/BMIReport" element={
          <ProtectedRoute requiredModule="MDM">
            <BMICalculation />
          </ProtectedRoute>
        } />
        <Route path="/certificate" element={
          <ProtectedRoute requiredModule="MDM">
            <Certificate />
          </ProtectedRoute>
        } />
        <Route path="/eggandbananaReport" element={
          <ProtectedRoute requiredModule="MDM">
            <EggandBananaRegisterBook />
          </ProtectedRoute>
        } />
        <Route path="/receipt" element={
          <ProtectedRoute requiredModule="MDM">
            <Receipt />
          </ProtectedRoute>
        } />

        <Route path="/paymentint" element={<PaymentPage />} />


        <Route path="/atm1" element={
          <ProtectedRoute requiredModule="Fee">
            <Stdfee />
          </ProtectedRoute>
        } />
        <Route path="/pavati" exact element={
          <ProtectedRoute requiredModule="Fee">
            <Pavati />
          </ProtectedRoute>
        } />
        <Route path="/pavatino" exact element={
          <ProtectedRoute requiredModule="Fee">
            <Pavatino />         </ProtectedRoute>
        } />
        <Route path="pavatino1" exact element={
          <ProtectedRoute requiredModule="Fee">
            <Pavatino1 />        </ProtectedRoute>
        } />
        <Route path="driver" exact element={
          <ProtectedRoute requiredModule="Fee">
            <Driver />
          </ProtectedRoute>
        } />
        <Route path="year" exact element={
          <ProtectedRoute requiredModule="Fee">
            <Yearpavati />       </ProtectedRoute>
        } />
        <Route path="update" exact element={
          <ProtectedRoute requiredModule="Fee">
            <UpadatedReport />   </ProtectedRoute>
        } />
        <Route path="feepavati" exact element={
          <ProtectedRoute requiredModule="Fee">
            <Feepavati />        </ProtectedRoute>
        } />
        <Route path="feepavati2" exact element={
          <ProtectedRoute requiredModule="Fee">
            <Feepavati2 />       </ProtectedRoute>
        } />
        <Route path="rootpavati" exact element={
          <ProtectedRoute requiredModule="Fee">
            <Rootpavati />       </ProtectedRoute>
        } />
        <Route path="driverpavati" exact element={
          <ProtectedRoute requiredModule="Fee">
            <Driverpavati />     </ProtectedRoute>
        } />
        <Route path="/distribution" element={
          <ProtectedRoute requiredModule="Fee">
            <Distribution />     </ProtectedRoute>
        } />
        <Route path="/pendingfee" element={
          <ProtectedRoute requiredModule="Fee">
            <AddPendingfee />    </ProtectedRoute>
        } />




        <Route path="/nirgam" element={<NirgamReport />} />
        <Route path="/UpdateStudentPhotos" element={<UpdateStudentPhotos />} />


        <Route path="/studentresult" element={<StudentResult />} />
        <Route path="/taketest" element={<TakeTest />} />
        <Route path="/teacherandqueform" element={<TeacherAndQuestionForm />} />


        <Route path="/instock" element={<Instock />} />
        <Route path="/outstock" element={<Outstock />} />
        <Route path="/balancestock" element={<BalanceStock />} />

        <Route path="/addteacher" element={
          <ProtectedRoute requiredModule="Payroll">
            <AddTeacher />
          </ProtectedRoute>
        } />

        <Route path="/attendance-staff-report" element={<AttendanceStaffReport />} />
        <Route path="/bank-details" element={<BankDetails />} />

        <Route path="/dailyreport" element={
          <ProtectedRoute requiredModule="Payroll">
            <DailyReport />          </ProtectedRoute>
        } />

        <Route path="/date-of-join-report" element={
          <ProtectedRoute requiredModule="Payroll">
            <DateOfJoinReport />
          </ProtectedRoute>
        } />
        <Route path="/EditAttendance/:some" element={
          <ProtectedRoute requiredModule="Payroll">
            <EditAtendance />
          </ProtectedRoute>
        } />
        <Route path="/female-staff-report" element={
          <ProtectedRoute requiredModule="Payroll">
            <FemaleStaffReport />
          </ProtectedRoute>
        } />
        <Route path="/male-staff-report" element={
          <ProtectedRoute requiredModule="Payroll">
            <MaleStaffReport />
          </ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute requiredModule="Payroll">
            <Profile />
          </ProtectedRoute>
        } />
        <Route path="/salary-details" element={
          <ProtectedRoute requiredModule="Payroll">
            <SalaryDetails />
          </ProtectedRoute>
        } />
        <Route path="/shift-time" element={
          <ProtectedRoute requiredModule="Payroll">
            <ShiftTime />
          </ProtectedRoute>
        } />
        <Route path="/teacherinfo" element={
          <ProtectedRoute requiredModule="Payroll">
            <TeacherInfo />
          </ProtectedRoute>
        } />
        <Route path="/teacher-info-report" element={
          <ProtectedRoute requiredModule="Payroll">
            <TeacherInfoReport />
          </ProtectedRoute>
        } />
        <Route path="/total-staff-report" element={
          <ProtectedRoute requiredModule="Payroll">
            <TotalStaffReport />
          </ProtectedRoute>
        } />
        <Route path="/user-permission" element={
          <ProtectedRoute requiredModule="Payroll">
            <UserPermission />
          </ProtectedRoute>
        } />
        <Route path="/view-attendance/:employeeName" element={
          <ProtectedRoute requiredModule="Payroll">
            <ViewAttendance />
          </ProtectedRoute>
        } />

        <Route path="/tIdCard" element={
          <ProtectedRoute requiredModule="Payroll">
            <TIdCard />
          </ProtectedRoute>
        } />

        <Route path='/addSubject' element={<AddSubject />} />
        <Route path="/principleform" element={<PrincipleForm />} />
        <Route path="/teachertimetable" element={<TeacherTimetable />} />
        <Route path="/timetableform" element={<TimetableForm />} />
        <Route path="/timetableform1" element={<Timetableform1 />} />
        <Route path="/weekdayform" element={<WeekdayForm />} />


        <Route path="/admission-details" element={<AdmissionData />} />
        <Route path="/promote" element={<PromoteStd />} />
        <Route path='/defaultsetting' element={<Defaultsettings />} />
        <Route path="/whatsapp" element={<WhatsAppManagement />} />
        <Route path="/permissionAccess" exact element={<PermissionAccess />} />


        <Route path="/preprimary" element={
          <ProtectedRoute requiredModule="Result">
            <PreparimaryResult />
          </ProtectedRoute>
        } />
        <Route path="/cbsesubjectcwise" element={
          <ProtectedRoute requiredModule="Result">
            <CbseSubjectWise />
          </ProtectedRoute>
        } />
        <Route path="/cbsemarkentery" element={
          <ProtectedRoute requiredModule="Result">
            <CbseMarkEntery />
          </ProtectedRoute>
        } />
        <Route path="/cbseresult" element={
          <ProtectedRoute requiredModule="Result">
            <CbseResult />
          </ProtectedRoute>
        } />
        <Route path="/cbsehsresult" element={
          <ProtectedRoute requiredModule="Result">
            <CbseHighSchoolResult />
          </ProtectedRoute>
        } />
        <Route path="/plans" element={<Plans />} />


        <Route path="/department" element={<Department />} />

        <Route path="/feedashboard" element={<FeeDashboard />} />
        <Route path="/divisionwisefee/:className/:division" element={<Divisionwisefee />} />
        <Route path="/stdfeenamelist/:className/:division" element={<Stdfeenamelist />} />



        <Route path="/sendmsg" element={<WhatsAppSender />} />
      </Routes>
    </>
  );
};

const AuthenticatedRoutes = WithAuth(AuthenticatedApp);

const App = () => {
  const location = useLocation();

  const hideNavbarAndFooter = location.pathname === '/eguruji-landingpage';
  const hideNavbarAndFooter2 = location.pathname === '/admission-from';
  return (
    <>
      {!hideNavbarAndFooter && !hideNavbarAndFooter2 && <Navbar />}
      <Routes>
        <Route path="/webresult/:udiseNumber/:srNo/:academicYear/:classValue/:division/:selectedExamName" element={<WebResult />} />
        <Route path="/webhsc/:udiseNumber/:srNo/:academicYear/:classValue/:division/:selectedExamName" element={<WebHSC />} />
        <Route path="/webssc/:udiseNumber/:srNo/:academicYear/:classValue/:division/:selectedExamName" element={<WebSSC />} />
        <Route path="/webboard/:udiseNumber/:srNo/:academicYear/:classValue/:division/:selectedExamName" element={<WebBoardResult />} />
        <Route path="/webicse/:udiseNumber/:srNo/:academicYear/:classValue/:division/:selectedExamName" element={<WebIcseResult />} />
        <Route path="/webprelims/:udiseNumber/:srNo/:academicYear/:classValue/:division/:selectedExamName" element={<WebPrelimsResult />} />

        <Route path="/admission-from" element={<SchoolAdmissionForm />} />
        <Route path="/downloadexe-landingpage" element={<Downloadexe />} />
        <Route path="/eguruji-landingpage" element={<LandingPage />} />
        <Route path="/" element={<LoginForm />} />
        <Route path="/plans-for-user" element={<Plansforuser />} />
        <Route path="/school-register" element={<SchoolRegister />} />
        <Route path="/sc-reg" element={<SchoolregNoOTP />} />

        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/test/:udiseNo/:class/:division/:subject/:testName" element={<StudentTestPage />} />
        <Route path="/*" element={<AuthenticatedRoutes />} />
        <Route path="/feedback/:ticketId" element={<CustomerFeedback />} />


      </Routes>
      {!hideNavbarAndFooter && !hideNavbarAndFooter2 && <Footer />}
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
